import {svgIconWrapper} from '../svg-icon-wrapper';

import BranchRegular from './branch-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BranchRegular {...validProps} />;
}

SvgComponent.iconName = 'branch-regular';

export const BranchRegularIcon = svgIconWrapper(SvgComponent);
